// Copyright 2022-2023 @Polkasafe/polkaSafe-ui authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

import React from 'react';
import AllApps from 'src/components/Apps/index';

const Apps = () => {
	return (
		<div className='scale-[80%] h-[125%] w-[125%] origin-top-left'>
			<AllApps/>
		</div>
	);
};

export default Apps;
